import { useState, useEffect } from "react";
import { CalendarDays, PartyPopper } from "lucide-react";
import { feteDuJour } from "@/lib/fetes";

const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

// Under the search bar: current date + live time on the left, saint of the day on
// the right. Responsive so it fits phones (short date) and stays on one clean row.
export const DateFeteBar = () => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 15000);
    return () => clearInterval(t);
  }, []);

  const dateFull = cap(now.toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" }));
  const dateShort = cap(now.toLocaleDateString("fr-FR", { weekday: "short", day: "numeric", month: "short" }));
  const timeStr = now.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
  const fete = feteDuJour(now);

  return (
    <div className="mt-2 flex items-center justify-between gap-2 text-xs sm:text-sm whitespace-nowrap" data-testid="date-fete-bar">
      <span className="flex items-center gap-1.5 text-muted-foreground min-w-0 shrink" data-testid="date-time-left">
        <CalendarDays className="w-3.5 h-3.5 shrink-0 text-primary" />
        <span className="truncate">
          <span className="sm:hidden">{dateShort}</span>
          <span className="hidden sm:inline">{dateFull}</span>
        </span>
        <span className="font-mono font-semibold text-foreground shrink-0">· {timeStr}</span>
      </span>
      {fete && (
        <span className="flex items-center gap-1.5 shrink-0 text-muted-foreground min-w-0" data-testid="fete-right">
          <PartyPopper className="w-3.5 h-3.5 shrink-0 text-primary" />
          <span className="truncate">
          <span className="hidden sm:inline">Bonne fête&nbsp;: </span>
            <span className="font-semibold text-foreground">{fete}</span>
          </span>
        </span>
      )}
    </div>
  );
};
